import { createFileRoute } from "@tanstack/react-router";

import { JsonLd } from "@/components/site/JsonLd";
import { CtaBand, LocationCard, TrustBar } from "@/components/site/Sections";
import { SiteLayout } from "@/components/site/SiteLayout";
import { WhatsAppButton } from "@/components/site/WhatsAppChat";
import { business, fullAddress } from "@/lib/business";
import { breadcrumbSchema, canonicalLink, metaFor } from "@/lib/seo";

const title = "Contato Chavel Chaveiro Betim | (31) 3531-3544";
const description =
  "Fale com a Chavel Chaveiro em Betim: WhatsApp e telefone (31) 3531-3544, loja na Av. Amazonas, 1354 - Lj 01, Brasiléia. Atendimento 24h em emergências.";

export const Route = createFileRoute("/contato")({
  head: () => ({
    meta: metaFor({ title, description, path: "/contato" }),
    links: canonicalLink("/contato"),
  }),
  component: ContatoPage,
});

function ContatoPage() {
  return (
    <SiteLayout>
      <JsonLd
        data={breadcrumbSchema([
          { name: "Início", url: "/" },
          { name: "Contato", url: "/contato" },
        ])}
      />

      <section className="bg-surface text-surface-foreground">
        <div className="container-page py-14">
          <h1 className="font-display text-4xl">Contato da Chavel Chaveiro em Betim</h1>
          <p className="mt-4 max-w-3xl opacity-90">
            Estamos na {fullAddress}. Atendemos na loja, a domicílio em toda Betim e com plantão de emergência 24 horas.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <WhatsAppButton variant="gold">Conversar no WhatsApp</WhatsAppButton>
            <a
              href={`tel:${business.phoneRaw}`}
              className="inline-flex items-center rounded-full border border-white/30 px-6 py-3 text-sm font-semibold hover:bg-white/10"
            >
              Ligar {business.phone}
            </a>
          </div>
        </div>
      </section>

      <TrustBar />

      <div className="container-page grid gap-8 py-12 lg:grid-cols-2">
        <LocationCard />
        <div className="rounded-xl border border-border bg-card p-6">
          <h2 className="font-display text-2xl">Como funciona o atendimento</h2>
          <ol className="mt-4 list-decimal space-y-2 pl-5 text-sm text-muted-foreground">
            <li>Você abre o chat e informa o serviço e o bairro em Betim.</li>
            <li>As informações são registradas e enviadas direto para o WhatsApp da loja.</li>
            <li>Confirmamos o valor estimado e o tempo de chegada antes de sair.</li>
            <li>O técnico executa o serviço com garantia e emissão de comprovante.</li>
          </ol>
          <h3 className="mt-6 text-lg font-semibold">Regiões atendidas</h3>
          <p className="mt-2 text-sm text-muted-foreground">{business.neighborhoods.join(" • ")} e demais bairros de Betim.</p>
        </div>
      </div>

      <div className="container-page pb-12">
        <div className="overflow-hidden rounded-xl border border-border">
          <iframe
            title="Mapa da Chavel Chaveiro em Betim"
            src={`https://www.google.com/maps?q=${encodeURIComponent(fullAddress)}&output=embed`}
            width="100%"
            height="380"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>

      <CtaBand title="Emergência agora?" text="Ligue ou chame no WhatsApp: (31) 3531-3544, 24 horas." />
    </SiteLayout>
  );
}
